import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SecurityModule} from "../security/security.module";
import {ServicesModule} from "../services/services.module";
import {RECAPTCHA_KEY} from "../services/recaptcha.service";

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        SecurityModule.forRoot(),
        ServicesModule.forRoot()
    ],
    providers: [
        {
            provide: RECAPTCHA_KEY,
            useValue: '6LeyeaYZAAAAAINO2y3Nfgv2E401flX4wVOgfQim'
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
